import { Environments } from '../types/environments.types';
import { US_REGION_SHORT_NAME } from './constants';
import { getEnvironment, isEnvironment } from './environment';
import { getUrlEnvLetterFromEnv } from './generateWlc360iUrl';
import { getRegionShortName } from './getRegion';
const bucketPrefixes = {
    imageUpload: 'saas-image-management-uploads',
    reportTemplate: 'saas-export-service-exports',
};
// wlc360i for services migrated to the wlc360i CloudOS account (e.g. image management)
// wlc360p for services migrated to the wlc360p CloudOS account (e.g. sensor/export service)
const bucketAccountPrefixes = {
    imageUpload: 'wlc360i',
    reportTemplate: 'wlc360p',
};
/**
 * Returns the wlc moniker segment: {accountPrefix}-{envLetter}-{regionShort}.
 * DEV, QA, and STAGE always use US region (uw2). Only PROD uses the detected region.
 */
const getWlcMoniker = (accountPrefix, env) => {
    const envLetter = getUrlEnvLetterFromEnv(env);
    const regionShortName = env === Environments.PROD
        ? getRegionShortName()
        : US_REGION_SHORT_NAME;
    return `${accountPrefix}-${envLetter}-${regionShortName}`;
};
/**
 * Resolves the S3 bucket name for the current env/region.
 * Legacy bucket names are not handled here; consuming apps gate on feature flags.
 */
export const getBucketName = (bucket, environmentOverride) => {
    const env = isEnvironment(environmentOverride)
        ? Environments[environmentOverride]
        : getEnvironment();
    const moniker = getWlcMoniker(bucketAccountPrefixes[bucket], env);
    return `${bucketPrefixes[bucket]}-${moniker}`;
};
